/**
 * 为什么代码大体一致，为什么不复用income-data 的代码？
 * 因为总览和收入分析毕竟是两个模块（未来还会有其他模块），未来产品可能单独针对某个模块进行调整
 * 耦合太重，不利于后续维护，所以最终决定拆分，模块之间单独维护
**/

import { onMounted, ref} from "@vue/composition-api"
import { chartData, dashboardDetail } from '../api/index';
import { fillerConfig, fitlerTableChartId, filterBatchChartItemSelector, fillterSelectList, createFilterForm, queryConditions, fillerRequestChartId } from '../filter';
import { cloneDeep } from "lodash-es";
import { handleErrorMessageToast, handleWarningMessageToast } from '@/common/util';
import {
    NewSelectorConfigType,
    ChartDataCardRecordType,
    ChartLineDataType,
    FilterFormItemType,
    ChartsType
} from '../types';

export function useOverviewData(props: any, content: any) {
    const dashboardData = ref();
    const newCardConfig = ref<NewSelectorConfigType | null>(null); // 重新过滤生成新的card config
    const newCorePannelLineConfig = ref<NewSelectorConfigType | null>(null); // 过滤生成新的核心概览-折线图 config
    const corePannelLineChartData = ref<ChartLineDataType | null>(null) // 核心概览 折线图数据
    const cardData = ref<ChartDataCardRecordType[]>([]); // card 数据
    const fillterForm = ref<FilterFormItemType[]>([]); // chart的查询条件

    // 获取 card chart data
    async function getCardChart() {
        // 参数会有一些统一的处理
        const conditionsQuery = queryConditions(cloneDeep(fillterForm.value));
        const params =  {
            chartId: newCardConfig.value!.chartId,
            selector: newCardConfig.value!.needSelectorsfieldName,
            conditions: conditionsQuery,
            granularity: "day",
            sorts: [] as [],
            limit: 30,
            offset: 0
        }
        try {
            const res = await chartData(params);
            if(res.data.result === 1) {
                cardData.value = res.data.data.records;
            } else {
                handleErrorMessageToast(res.data.msg || res.data.error_msg || '系统异常');
            }
        } catch(err) {
            handleErrorMessageToast(err.error_msg || err.msg ||'系统异常，请稍后再试')
        }
    }

    // 获取核心数据概览折线图chart Data TODO: 与 getCardChart合并成一个方法
    async function getCorePannelLineChart() {
        const conditionsQuery = queryConditions(cloneDeep(fillterForm.value));
        const params =  {
            chartId: newCorePannelLineConfig.value!.chartId,
            selector: newCorePannelLineConfig.value!.needSelectorsfieldName,
            conditions: conditionsQuery,
            granularity: "day",
            sorts: [] as [],
            limit: 30,
            offset: 0
        }
        try {
            const res = await chartData(params);
            if(res.data.result === 1) {
                corePannelLineChartData.value = res.data.data;
            } else {
                handleErrorMessageToast(res.data.msg || res.data.error_msg || '系统异常');
            }
        } catch(err) {
            handleErrorMessageToast(err.error_msg || err.msg ||'系统异常，请稍后再试')
        }
    }


    // 获取【总览】的所有配置项
    async function getDashboard()  {
        try {
            const { data } = await dashboardDetail(props.tabActive);
            if(data.result === 1) {
                dashboardData.value = data.data;
                // 生成默认的查询条件
                fillterForm.value = createFilterForm(data.data.conditions, props.appId);
                // 核心概览pannel TODO: 先暂时用0，因为配置上顺序是固定的，不可更改的，后续看是否有其他方法
                const corePannel = data.data.panels[0]
                // 过滤出原有卡片数据
                const oldCard = corePannel.charts.find((item: ChartsType) => item.chartCode === 'totalInfoOverviewCard');

                // 根据游戏类型组合成新的card config
                newCardConfig.value = fillerConfig(oldCard!, props.gameType);

                // 根据游戏类型组合成新的核心概览-line config
                newCorePannelLineConfig.value = fillerConfig(corePannel.charts.find((item: ChartsType) => item.chartCode === 'totalInfoOverviewLine')!, props.gameType);

            } else {
                handleErrorMessageToast(data.msg || data.error_msg || '系统异常');
            }

        } catch(err) {
            console.log(err)
            handleErrorMessageToast(err.error_msg || err.msg ||'系统异常，请稍后再试')
        }
    }

    onMounted(async () => {
        // 获取dashboard,其余接口会在dashbord结果返回后触发vue 里的watch，再请求
        getDashboard()
    })

    return {
        newCorePannelLineConfig,
        fillterForm,
        dashboardData,
        newCardConfig,
        corePannelLineChartData,
        cardData,
        getCardChart,
        getDashboard,
        getCorePannelLineChart
    }
}
